import { render } from "./TeacherAssessment.vue?vue&type=template&id=069dd81f&scoped=true"
import script from "./TeacherAssessment.vue?vue&type=script&lang=js"
export * from "./TeacherAssessment.vue?vue&type=script&lang=js"

import "./TeacherAssessment.vue?vue&type=style&index=0&id=069dd81f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069dd81f"]])

export default __exports__